import 'es6-promise/auto';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue'
import { router } from './vuerouter.js'
import { store } from './vuexstore.js'
import { i18n } from './i18n.js'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import './custom.scss'
import Vuelidate from 'vuelidate'

import { VueReCaptcha } from 'vue-recaptcha-v3'

// For more options see below
//Vue.use(VueReCaptcha, { siteKey: '6Lft-TwbAAAAAFRQM4IMkbomegDIFml0Wo7P9Xl5' })
Vue.use(VueReCaptcha, { siteKey: '6LcvSUAbAAAAAMNEzHTrKgr_RoasP7Gk9B4Sq7A4' })

import VueSignature from "vue-signature-pad";
Vue.use(VueSignature);

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Vuelidate);
Vue.use(BootstrapVue);

Vue.config.productionTip = false;

new Vue({
  store,
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')

